import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import ProcessSection from "./components/ProcessSection";
import ClientLogos from "./components/ClientLogos";
import TestimonialsSection from "./components/TestimonialsSection";
import FaqSection from "./components/FaqSection";
import BookingForm from "./components/BookingForm";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";

function useRemoveBadge() {
  useEffect(() => {
    const remove = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) badge.parentNode.removeChild(badge);
      document.querySelectorAll('a[href*="emergent.sh"]').forEach((el) => {
        if (el.id === "emergent-badge" || el.textContent.includes("Emergent")) {
          el.parentNode.removeChild(el);
        }
      });
    };
    remove();
    const interval = setInterval(remove, 300);
    const observer = new MutationObserver(remove);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => { clearInterval(interval); observer.disconnect(); };
  }, []);
}

const LandingPage = () => (
  <>
    <Navbar />
    <HeroSection />
    <ServicesSection />
    <ProcessSection />
    <ClientLogos />
    <TestimonialsSection />
    <FaqSection />
    <BookingForm />
    <Footer />
  </>
);

function App() {
  useRemoveBadge();
  return (
    <div className="App" data-testid="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
